import PageShell from '@/components/PageShell';
import LeadForm from '@/components/LeadForm';

const Contact = () => {
  return (
    <PageShell>
      <section className="relative border-b border-white/10 overflow-hidden">
        <div className="absolute inset-0 grid-lines opacity-50" />
        <div className="absolute inset-0 radial-glow-amber opacity-40" />
        <div className="relative px-6 md:px-12 lg:px-16 pt-24 pb-16">
          <div className="overline text-amber mb-4">
            <span className="inline-flex items-center gap-2">
              <span className="h-px w-6 bg-amber inline-block" />
              Contact · Partner With Us
            </span>
          </div>
          <h1 className="font-display text-[40px] sm:text-5xl md:text-6xl lg:text-7xl text-balance max-w-4xl leading-[0.98]">
            Tell us what you're working on.
          </h1>
          <p className="mt-8 max-w-2xl text-zinc-300 text-base md:text-lg leading-relaxed">
            OEMs, dealer groups, insurers, lenders, fleets, founders — we read
            every message. If there's a fit, we'll get back within two
            business days.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-4 space-y-8">
            <div>
              <div className="overline mb-3">Who we work with</div>
              <ul className="space-y-2 text-zinc-300 text-sm leading-relaxed">
                <li>· Automotive OEMs (PV, CV, 2W, 3W, EV)</li>
                <li>· Dealer groups & retail networks</li>
                <li>· Insurers & underwriters</li>
                <li>· Vehicle financiers & lenders</li>
                <li>· Fleet operators & logistics</li>
                <li>· Founders building in mobility</li>
              </ul>
            </div>

            <div>
              <div className="overline mb-3">Group</div>
              <div className="font-mono text-sm text-zinc-300">
                themobilitygroup.co
              </div>
            </div>

            <div>
              <div className="overline mb-3">Email</div>
              <a
                href="mailto:sales@themobilitygroup.co"
                data-testid="contact-email"
                className="font-mono text-sm text-amber hover:underline break-all"
              >
                sales@themobilitygroup.co
              </a>
              <p className="mt-2 text-xs text-zinc-500 leading-relaxed">
                For sales, partnerships, media queries or anything that needs
                a human — write to us directly.
              </p>
            </div>

            <div className="border border-white/10 p-6 bg-ink-800">
              <div className="overline text-amber mb-3">In a hurry?</div>
              <p className="text-zinc-300 text-sm leading-relaxed">
                For time-sensitive partnerships or commercial conversations,
                start your message with{' '}
                <span className="font-mono text-amber">[URGENT]</span> and we'll
                prioritise it.
              </p>
            </div>
          </aside>

          <div className="lg:col-span-8">
            <LeadForm />
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default Contact;
